import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import icon from './images/ROSAFNewunscreen.gif';
import iconi from './images/create1.png';
import backk from './images/backk.png';
import swichh from './images/switchh.png';

const Teachh = () => {
    const navigate = useNavigate();
    const [userEmail, setUserEmail] = useState('');
    const [personName, setPersonName] = useState('');
    const [message, setMessage] = useState('');
    const [usingBackCamera, setUsingBackCamera] = useState(false);
    const videoRef = useRef(null);
    const canvasRef = useRef(null);

    const constraints = { video: { facingMode: usingBackCamera ? 'environment' : 'user' } };

    useEffect(() => {
        const email = sessionStorage.getItem('userEmail');
        setUserEmail(email);

        if (!email) {
            navigate('/signin');
            return;
        }

        async function getMedia() {
            if (videoRef.current && videoRef.current.srcObject) {
                videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
            }

            try {
                const stream = await navigator.mediaDevices.getUserMedia(constraints);
                videoRef.current.srcObject = stream;
            } catch (err) {
                console.error("Error accessing the camera: ", err);
                setMessage('Error accessing the camera');
            }
        }

        getMedia();
    }, [navigate, usingBackCamera]);

    const drawScannerOverlay = () => {
        const canvas = canvasRef.current;
        if (canvas) {
            const context = canvas.getContext('2d');
            const { width, height } = canvas;

            // Clear previous drawings
            context.clearRect(0, 0, width, height);

            // Define the size of the L-shaped corners
            const cornerLength = 20;
            const cornerThickness = 3;

            // Calculate the center rectangle coordinates
            const rectWidth = width * 0.5;
            const rectHeight = height * 0.5;
            const rectX = 35;
            const rectY = (height - rectHeight) / 2;

            context.strokeStyle = 'red';
            context.lineWidth = cornerThickness;
            const cornerOffset = 40;

        // Top-left corner

        context.beginPath();
        context.moveTo(rectX + cornerOffset, rectY + cornerOffset);  // Move corner closer
        context.lineTo(rectX + cornerOffset + cornerLength, rectY + cornerOffset); // Shortened distance
        context.moveTo(rectX + cornerOffset, rectY + cornerOffset);
        context.lineTo(rectX + cornerOffset, rectY + cornerOffset + cornerLength);  // Shortened distance
        context.stroke();

        // Top-right corner (shifted right)
        context.beginPath();
        context.moveTo(rectX + rectWidth - cornerOffset, rectY + cornerOffset);  // Move corner closer
        context.lineTo(rectX + rectWidth - cornerOffset - cornerLength, rectY + cornerOffset); // Shortened distance
        context.moveTo(rectX + rectWidth - cornerOffset, rectY + cornerOffset);
        context.lineTo(rectX + rectWidth - cornerOffset, rectY + cornerOffset + cornerLength);  // Shortened distance
        context.stroke();

        // Bottom-left corner (shifted right)
        context.beginPath();
        context.moveTo(rectX + cornerOffset, rectY + rectHeight - cornerOffset);  // Move corner closer
        context.lineTo(rectX + cornerOffset + cornerLength, rectY + rectHeight - cornerOffset); // Shortened distance
        context.moveTo(rectX + cornerOffset, rectY + rectHeight - cornerOffset);
        context.lineTo(rectX + cornerOffset, rectY + rectHeight - cornerOffset - cornerLength);  // Shortened distance
        context.stroke();

        // Bottom-right corner (shifted right)
        context.beginPath();
        context.moveTo(rectX + rectWidth - cornerOffset, rectY + rectHeight - cornerOffset);  // Move corner closer
        context.lineTo(rectX + rectWidth - cornerOffset - cornerLength, rectY + rectHeight - cornerOffset); // Shortened distance
        context.moveTo(rectX + rectWidth - cornerOffset, rectY + rectHeight - cornerOffset);
        context.lineTo(rectX + rectWidth - cornerOffset, rectY + rectHeight - cornerOffset - cornerLength);  // Shortened distance
        context.stroke();
    }
};
    useEffect(() => {
        drawScannerOverlay();
    });

    const dataURLToBlob = (dataURL) => {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };

    const checkDuplicateRecord = async () => {
        try {
            const response = await fetch('https://www.d-rosa.ai/CheckDuplicateRecord', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Gmail: userEmail,
                    PersonName: personName,
                    Imagepath: `/var/www/myflaskapp/flask_static/${userEmail}/Rosaf/${personName}.png`
                }),
            });
            const data = await response.json();
            return data.exists; // true if duplicate exists, false otherwise
        } catch (error) {
            console.error('Error checking for duplicates:', error);
            setMessage('Failed to check for duplicates');
            return false;
        }

    };

    const capture = async () => {
        if (!personName) {
            setMessage('Please enter a person name');
            return;
        }

        const duplicateExists = await checkDuplicateRecord();
        if (duplicateExists) {
            alert('Record Exists');
            return;
        }

        const context = canvasRef.current.getContext('2d');
        context.drawImage(videoRef.current, 0, 0, canvasRef.current.width, canvasRef.current.height);
        const dataURL = canvasRef.current.toDataURL('image/png');
        const blob = dataURLToBlob(dataURL);

        const formData = new FormData();
        const imageName = `${personName}.png`;
        formData.append('image', blob, imageName);
        formData.append('path', `/var/www/myflaskapp/flask_static/${userEmail}/Rosaf`);

        await handleImageSubmit(formData, imageName);

        alert('Record Successfully Updated');
    };

    const handleImageSubmit = async (formData, imageName) => {
        try {
            console.log('Sending image to IMGAPI');
            const picapiResponse = await fetch('https://www.d-rosa.ai/WHITEBACKGROUNDAPI', {
                method: 'POST',
                body: formData,
            });
            const data = await picapiResponse.json();
            console.log('IMGAPI response:', data.message);
            setMessage(data.message || 'Image captured and stored successfully');

            // Update the image path with the new image name
            const imagePath = `/var/www/myflaskapp/flask_static/${userEmail}/Rosaf/${imageName}`;
            const imgPathResponse = await fetch('https://www.d-rosa.ai/Imgpath', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    image_path: imagePath,
                    Gmail: userEmail,
                    PersonName: personName,

                    TABLE: 'RosaF',
                    FIELD: 'Imagepath',
                }),
            });
            const imgPathData = await imgPathResponse.json();
            console.log('Imgpath response:', imgPathData.message);
            setMessage('Record updated successfully!');
            alert('Record Successfully Updated');
        } catch (error) {
            console.error('Error capturing or sending image:', error);
            setMessage('Failed to capture or store image');
        }
    };

    const handleCreate = async () => {
        if (!personName) {
            setMessage('Please enter a person name');
            return;
        }

        // Check if a duplicate record exists
        const duplicateExists = await checkDuplicateRecord();
        if (duplicateExists) {
            alert('Record Exists');
            return; // Stop if duplicate found
        }

        const sqlQuery = 'INSERT INTO RosaF (Gmail, PersonName) VALUES (%s, %s)';
        const values = [userEmail, personName];

        try {
            const response = await fetch('https://www.d-rosa.ai/DBWRTAPI', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    query: sqlQuery,
                    values: values,
                }),
            });
            const result = await response.json();
            setMessage(result.message || `Error: ${result.error}`);
            setMessage('Data inserted Successfully'); // Update message for success
            alert('Data inserted Successfully'); // Show alert for success
        } catch (error) {
            console.error('Error:', error);
            setMessage('Failed to add person name');
        }
    };

    const handleInputChange = (e) => {
        setPersonName(e.target.value);
    };

    const handleBackClick = () => {
        navigate(-1);
    };

    const handleSwitchCamera = () => {
        setUsingBackCamera((prev) => !prev);
    };

    if (!userEmail) {
        return null;
    }

    return (
        <div style={{ background: 'linear-gradient(to bottom, #fff7ad, #ffa9f9)', minHeight: '100vh', padding: '20px', color: '#E11584' }}>
            <p>{message}</p>
            <img id="myimage" src={icon} alt="img" width="140" height="150" />
            <h2 className="center-heading" style={{ color: '#E11584', fontSize: '32px' }}>Teach Screen</h2><br />
            <p>Signed in as: {userEmail}</p>
            <label>
                PersonName:
                <br />
                <br />
                <input
                    type="text"
                    value={personName}
                    onChange={handleInputChange}
                    placeholder="Enter person's name"
                    required
                    style={{ color: '#E11584' }} 
                />
            </label>
            <button type="button" onClick={handleCreate}>
                <img src={iconi} width="40" height="10" alt="img" />
            </button>
            <br /><br />
            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                <video ref={videoRef} width="480" height="360" autoPlay></video>
                <canvas ref={canvasRef} width="480" height="360" style={{ position: 'absolute', pointerEvents: 'none' }}></canvas>
            </div>
            <br /><br />
            <button
                type="button"
                onClick={capture}
                style={{
                    backgroundColor: '#E11584',
                    color: 'white',
                    padding: '10px 20px',
                    border: '2px solid #E11584',
                    borderRadius: '5px',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    cursor: 'pointer',
                }}
            >
                Submit
            </button>
            <br /><br />
            <button
                type="button"
                onClick={handleSwitchCamera}
                style={{
                    backgroundColor: '#E11584',
                    color: 'white',
                    padding: '10px 20px',
                    border: '2px solid #E11584',
                    borderRadius: '5px',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    cursor: 'pointer',
                }}
            >
                <img src={swichh} width="30" height="40" alt="img" />
            </button>
            <br /><br />
            <button
                type="button"
                onClick={handleBackClick}
                style={{
                    backgroundColor: '#E11584',
                    color: 'white',
                    padding: '10px 20px',
                    border: '2px solid #E11584',
                    borderRadius: '5px',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    cursor: 'pointer',
                }}
            >
                <img src={backk} width="30" height="40" alt="img" />
            </button>
        </div>
    );
};

export default Teachh;
